import { FlatList } from "native-base";
import React from "react";

import { useCartController } from "@/contexts/CartControllerContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { OrderItem } from "@/interfaces/domain/Order";
import { CartNavigation } from "@/navigation/stacks/CartStack";

import CartItem from "./CartItem";

type CartItemListProps = {
  items: OrderItem[];
};

const CartItemList = ({ items }: CartItemListProps) => {
  const { decreaseItem, increaseItem } = useCartController();
  const { navigate } = useAppNavigation<CartNavigation>();

  const onSelect = (itemId: string) => {
    navigate("product", { productId: itemId });
  };

  return (
    <FlatList
      data={items}
      showsVerticalScrollIndicator={false}
      nestedScrollEnabled
      keyExtractor={(item, index) => (item ? item?.item?._id : index.toString())}
      renderItem={({ item }) => (
        <CartItem
          item={item}
          onPressDecrease={() => decreaseItem(item)}
          onPressIncrease={() => increaseItem(item)}
          onSelect={() => onSelect(item?.item?._id)}
        />
      )}
    />
  );
};

export default CartItemList;
